import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateTransactionStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateTransactionStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateTransactionStatusAttempt', handleUpdateTransactionStatus, api);
}

function* handleUpdateTransactionStatus(api: ApprovalGateway, data: PayloadAction<TUpdateTransactionStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        transactionId,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateTransactionStatus], {
        authToken,
        transactionId,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateTransactionStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const pendingTransactionListing = reduxState.approval.pendingTransactionListing.data;
        const pendingTransactionListingIndex = reduxState.approval.pendingTransactionListing.index;
        const oldStatus = pendingTransactionListing.find(item => item.transactionId === transactionId)?.status;
        const successMessage = status === TransactionStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveTransactionSuccess
            : status === TransactionStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectTransactionSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateTransactionStatusModalIsOpen(false));

        toast.success(successMessage);

        if (status === oldStatus) {
            yield put(combinedActions.approvalUpdateTransactionStatusSuccess());
            return;
        }

        if (pendingTransactionListing.length === 1) {
            yield put(combinedActions.approvalSetPendingTransactionListingIndex({ index: pendingTransactionListingIndex > 0 ? pendingTransactionListingIndex - 1 : 0 }));
        }

        yield put(combinedActions.approvalGetPendingTransactionListingAttempt());
        yield put(combinedActions.approvalUpdateTransactionStatusSuccess());
    }
}
